export default {
  heading: 'Circular-Book',
  body: 'Circular-Book',
};
